const CARDINAL_DEGREES: Record<string, number> = {
  N: 0,
  NNE: 22.5,
  NE: 45,
  ENE: 67.5,
  E: 90,
  ESE: 112.5,
  SE: 135,
  SSE: 157.5,
  S: 180,
  SSW: 202.5,
  SW: 225,
  WSW: 247.5,
  W: 270,
  WNW: 292.5,
  NW: 315,
  NNW: 337.5,
};

/**
 * Convert a cardinal compass string (e.g. 'N', 'SSW') to degrees. Accepts a
 * numeric string / number too (passes it through). Unknown values → 0.
 * Moved here from the old WindLayer.jsx so the wind module owns it.
 */
export function cardinalToDegrees(cardinal: string | number | null | undefined): number {
  if (cardinal == null) return 0;
  if (typeof cardinal === 'number') return cardinal;
  const key = cardinal.toUpperCase().trim();
  const mapped = CARDINAL_DEGREES[key];
  if (mapped !== undefined) return mapped;
  const numeric = Number(key);
  return Number.isFinite(numeric) ? numeric : 0;
}

/** Knots per km/h. */
export const KMH_TO_KT = 0.539957;
